import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/inventory')({
  // Deep-link contract (dashboard queues, saved links): ?status= & ?q= preset
  // filters, ?part= opens the detail drawer, ?add=1 opens the intake form.
  validateSearch: (search) => ({
    status: typeof search.status === 'string' ? search.status : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    part: typeof search.part === 'string' ? search.part : undefined,
    add: search.add ? 1 : undefined,
  }),
});
